/**
 * Validates a Portuguese Citizen Card (Cartão de Cidadão) number.
 * The CC has 12 alphanumeric characters and uses the Luhn (mod 10) algorithm for validation.
 *
 * @param value - The CC number to validate
 * @returns true if the CC is valid, false otherwise
 */
export const isValidPortugueseCC = (value: string): boolean => {
  const normalized = value.replace(/[\s-]/g, '').toUpperCase();

  if (normalized.length !== 12) {
    return false;
  }

  const mappedValues: number[] = [];
  for (const char of normalized) {
    if (char >= '0' && char <= '9') {
      mappedValues.push(parseInt(char, 10));
    } else if (char >= 'A' && char <= 'Z') {
      mappedValues.push(char.charCodeAt(0) - 'A'.charCodeAt(0) + 10);
    } else {
      return false;
    }
  }

  let sum = 0;
  for (let i = 11; i >= 0; i--) {
    let val = mappedValues[i];
    const positionFromRight = 11 - i;
    if (positionFromRight % 2 === 1) {
      val *= 2;
      if (val >= 10) {
        val -= 9;
      }
    }
    sum += val;
  }

  return sum % 10 === 0;
};
